import {AutoField} from 'components/forms/fields';
import Section from 'components/forms/Section';
import {Typography} from '@material-ui/core';
import {Alert} from '@material-ui/lab';
import fields from '../fields';
import {useFieldData} from 'components/forms/hooks';
import {RequiresSignatureAbortButton} from 'components/forms/sections';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import Show from 'components/utils/Show';

const Signature = props => {
    const {schema, initialValues} = bootstrapOldForm('Signature', fields);
    const [sslAttached, setSslAttached] = useFieldData('_ssl_attached');
    const [signed, setSigned] = useFieldData('_document_signed');
    const [officialLetterhead, setOfficialLetterhead] = useFieldData(
        '_official_letterhead'
    );

    const showWarning =
        signed === false ||
        signed === 'false' ||
        officialLetterhead === false ||
        officialLetterhead === 'false';

    const updateSslAttached = event => {
        setSslAttached(event.target.value === 'true');
    };

    const updateOfficialLetterhead = event => {
        setOfficialLetterhead(event.target.value === 'true');
    };
    const updateSigned = event => {
        setSigned(event.target.value === 'true');
    };

    return (
        <Section {...props} {...{schema, initialValues}}>
            <Typography variant='body1' align='left'>
                Let’s enter the information about this Tankerman letter.
            </Typography>
            <AutoField
                field={fields._ssl_attached}
                name='_ssl_attached'
                onChange={updateSslAttached}
            />
            <Show condition={sslAttached}>
                <Alert severity='info'>
                    Great! We'll ask you about this before wrapping up
                </Alert>
            </Show>
            <AutoField
                field={fields._official_letterhead}
                name='_official_letterhead'
                onChange={updateOfficialLetterhead}
            />
            <AutoField
                field={fields._document_signed}
                name='_document_signed'
                onChange={updateSigned}
            />
            <AutoField field={fields.date_signed} name='date_signed' />
            <AutoField field={fields.ssl_type} name='ssl_type' />
            {showWarning && <RequiresSignatureAbortButton />}
            {props.children}
        </Section>
    );
};

export default Signature;
